import React from 'react';
import { Typography, Button, Container, Box, Paper } from '@material-ui/core';
import { Link, Location, useLocation as useReachLocation } from '@reach/router'; // Changed imports for @reach/router
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  paper: {
    padding: theme.spacing(4),
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: '4rem',
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

// Using Location provider from @reach/router to access location.search
const PolarSHFailurePageContent = (props) => {
  const classes = useStyles();
  const { paymentOrderId, location } = props; // paymentOrderId from path, location from Location provider

  const queryParams = new URLSearchParams(location.search);
  const orderIdFromQuery = queryParams.get('paymentOrderId');
  const displayOrderId = paymentOrderId || orderIdFromQuery;

  const checkoutPath = displayOrderId ? `/checkout/${displayOrderId}` : "/checkout";

  return (
    <Container component="main" maxWidth="sm" className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="h4" component="h1" color="error" gutterBottom>
          Payment Failed
        </Typography>
        <Typography variant="body1">
          Unfortunately, your payment could not be processed or was cancelled.
          Please try again or select a different payment method.
        </Typography>
        {displayOrderId && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>
            Reference ID: {displayOrderId}
          </Typography>
        )}
        <Button
          component={Link}
          to={checkoutPath}
          variant="contained"
          color="primary"
          className={classes.button}
        >
          Try Again
        </Button>
        <Button
          component={Link}
          to="/"
          variant="outlined"
          color="secondary"
          className={classes.button}
          style={{ marginLeft: 10 }}
        >
          Go to Homepage
        </Button>
      </Paper>
    </Container>
  );
};

// Wrapper component to provide location context
function PolarSHFailurePage(props) {
  return (
    <Location>
      {({ location }) => <PolarSHFailurePageContent location={location} {...props} />}
    </Location>
  );
}

export default PolarSHFailurePage;
